import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const Typography = ({
  children,
  className,
  isNumeric = false,
  isVisible = true,
  tag: Tag = "span",
  transitionDuration,
  type,
  ...props
}) => {
  const classes = classNames(
    `axiom-typography--${type}`,
    { "axiom-typography--numeric": isNumeric },
    { "axiom-typography--invisible": !isVisible },
    { [`duration-${transitionDuration}`]: transitionDuration },
    className
  );
  return /* @__PURE__ */ jsx(Tag, { className: classes, ...props, children });
};
Typography.displayName = "Typography";

export { Typography };
